var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    transform: "translate(0 0.0483398)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8901 28.6682V36.4282M49.8901 28.6682C49.8901 24.3782 53.3601 20.9082 57.6501 20.9082C61.9401 20.9082 65.4101 24.3782 65.4101 28.6682C65.4101 32.9582 61.9401 36.4282 57.6501 36.4282H49.8901M49.8901 28.6682C49.8901 24.3782 46.4201 20.9082 42.1301 20.9082C37.8401 20.9082 34.3701 24.3782 34.3701 28.6682C34.3701 32.9582 37.8401 36.4282 42.1301 36.4282H49.8901",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.07 36.4282H27.72C25.2734 36.4282 23.29 38.4116 23.29 40.8582V47.5182C23.29 49.9648 25.2734 51.9482 27.72 51.9482H72.07C74.5167 51.9482 76.5 49.9648 76.5 47.5182V40.8582C76.5 38.4116 74.5167 36.4282 72.07 36.4282Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.895 32.0483L49.895 77.9692",
    stroke: "#2766B0",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0597 51.9482V71.8982C72.0597 75.5682 69.0797 78.5482 65.4097 78.5482H34.3697C30.6997 78.5482 27.7197 75.5682 27.7197 71.8982V51.9482",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit3);
export default __webpack_public_path__ + "static/media/benefit3.e99d3751a3685b151d0f3b99aa9701c3.svg";
export { ForwardRef as ReactComponent };